import { Routes } from '@angular/router';
import { authGuard } from './partials/guards/auth.guard';
import { homeRedirectGuard } from './partials/guards/home-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(({ MainLayoutComponent }) => MainLayoutComponent),
    children: [
      {
        path: '',
        canActivate: [homeRedirectGuard],
        children: [],
        pathMatch: 'full'
      },
      {
        path: 'case',
        loadComponent: () => import('./pages/case/case.component').then(({ CaseComponent }) => CaseComponent)
      },
      {
        path: 'case-list',
        loadComponent: () => import('./pages/case-list/case-list.component').then(({ CaseListComponent }) => CaseListComponent)
      },
      {
        path: 'case/:id',
        loadComponent: () => import('./pages/single-case/single-case.component').then(({ SingleCaseComponent }) => SingleCaseComponent)
      },
      {
        path: 'terms-of-use',
        loadComponent: () => import('./pages/terms-of-use/terms-of-use.component').then(({ TermsOfUseComponent }) => TermsOfUseComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(({ PrivacyPolicyComponent }) => PrivacyPolicyComponent)
      },
    ],
  },
  {
    path: '401',
    loadComponent: () => import('./pages/401/401.component')
  },
  {
    path: '409',
    loadComponent: () => import('./pages/something-went-wrong/something-went-wrong.component')
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];
